import { render, staticRenderFns } from "./Integrator.vue?vue&type=template&id=449b1e0c&scoped=true&"
import script from "./Integrator.vue?vue&type=script&lang=js&"
export * from "./Integrator.vue?vue&type=script&lang=js&"
import style0 from "@/assets/styles/beneficiary.css?vue&type=style&index=0&id=449b1e0c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "449b1e0c",
  null
  
)

export default component.exports